import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { PageContentService, SessionStorageService, ParameterConfigService, CSPReportService } from '../../core/index.service';
import { PageContent, CodedLookup, ParamInfo, Juris, CSPReport } from '../../core/index.model';
import { UserRole, ParamId } from '../../core/enumtype';

import { LoginComponent } from '../login/login.component';
import { ProfileInfoComponent } from '../login/profileinfo.component';
import { AlertComponent } from '../common/alert.component';

import { AuthenticationComponent } from '../common/index';
import { ConfigService } from '../../core/config.service';

@Component({
    moduleId: module.id,
    selector: 'shared-leftmenu',
    templateUrl: './leftmenu.component.html'
})
export class LeftMenuComponent implements OnInit  {
    currentPage: string;
    @Output() cmdLangClick: EventEmitter<string> = new EventEmitter<string>();
    @Output() cmdMenu: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() cmdJuris: EventEmitter<Juris> = new EventEmitter<Juris>();
    @Input() pageContent: PageContent;
   
    langList: CodedLookup[] = [];

    hideAgency: boolean = true;
    agencyName: string = 'Agencies';
    selectedAgency: string = '';
    showLoading: boolean;
    isLoading: boolean;

    cspreportList: CSPReport[];
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        public dialog: MatDialog,
        private paramConfigService: ParameterConfigService,
        private pageContentService: PageContentService,
        private storageService: SessionStorageService,
        private cspreportService: CSPReportService,
        private configService: ConfigService,
    ) 
    { 
        // To Get the Current Route

        this.router.events
            .filter((event) => event instanceof NavigationEnd)
            .subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    this.currentPage = event.urlAfterRedirects;
                }
            });
    }

    ngOnInit() {
        this.hideAgency = true;
    }

    cmdLanguageClick(strLang: string) {
        this.cmdMenu.emit(false);
        this.cmdLangClick.emit(strLang);
    }

    GetLanguageParamValue(): boolean {
        
        let temp: CodedLookup[] = [];
        let paramInfo: ParamInfo;
        let paramValue: any;

        paramInfo = this.paramConfigService.GetSystemParamInfo(ParamId.Languages);
        paramValue = this.paramConfigService.GetSystemParamValue(ParamId.Languages);
        if (paramInfo) {
            var langList = paramValue ? paramValue.split(',') : null;
            if (langList) {
                for (var i = 0; i < langList.length; i++) {
                    var language = paramInfo.CodedLookup ? paramInfo.CodedLookup.find(x => x.CodeValue == langList[i]) : null;
                    temp.push(language);
                }
            }
            this.langList = temp.length > 0 ? temp : paramInfo.CodedLookup ? paramInfo.CodedLookup : null;
        }
        return (this.langList) ? true : false;
    }

    // Open Login

    openLoginModal() {
        this.cmdMenu.emit(false);

        let dialogRef;

        if (this.storageService.getUserRole() === UserRole.Citizen) {
            dialogRef = this.dialog.open(ProfileInfoComponent, {
                disableClose: false,
                panelClass: 'profile-info-modal'
            });
        }
        else {
            dialogRef = this.dialog.open(LoginComponent, {
                disableClose: false,
                panelClass: 'login-modal'
            });
        }

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
            }
        });
    }

    cmdRedirect(strPage: string) {

        this.cmdMenu.emit(false);

        this.pageContentService.pageContentYN = true;

        if (this.currentPage == ("/" + strPage)) {
            this.pageContentService.pageContentYN = false;
        }

        let link = [strPage];
        this.router.navigate(link)
            .then(success => {
                if (success) {
                    this.pageContentService.pageContentYN = false;
                }
                else {
                    this.pageContentService.pageContentYN = false;

                    if (this.currentPage != ("/" + strPage)) {
                        this.dialog.closeAll();
                        this.dialog.open(AuthenticationComponent, {
                            disableClose: true,
                            panelClass: "alert-modal",
                            data: { message: strPage === 'services/location' ? 'House_Check' : 'TThe service is accessible to authenticated users only.', RouterLink: strPage}
                        });
                    }
                }
            })
            .catch(err => {
                this.pageContentService.pageContentYN = false;
            });
    }

    enableServiceLink(): boolean {
        return this.paramConfigService.enableLink();
    }

    showJurisList1(): boolean {
        if ((this.storageService.getUserRole() === UserRole.Anonymous || this.storageService.getUserRole() == UserRole.Citizen || this.storageService.getUserRole() === UserRole.Admin || this.storageService.getUserRole() === UserRole.SuperAdmin || this.storageService.getUserRole() === UserRole.Juris) && (this.storageService.getTenantState().Juris.length === 1)) {
            return false;
        }
        else if (this.storageService.getUserRole() == UserRole.Citizen || this.storageService.getUserRole() === UserRole.Admin || this.storageService.getUserRole() === UserRole.SuperAdmin || this.storageService.getUserRole() === UserRole.Juris) {
            this.selectedAgency = this.storageService.getJurisName();
            this.hideAgency = false;
            return true;
        }
        else if (this.storageService.getUserRole() == UserRole.Anonymous) {
           this.selectedAgency = this.storageService.getJurisName();
            this.agencyName = 'Agencies';
            this.hideAgency = true;
            return true;
        }
        else {
            this.agencyName = 'Agencies';
            this.hideAgency = true;
            return true;
        }
    }
    cmdJurisClick(juris: Juris) {
        this.cmdJuris.emit(juris);
        this.storageService.setJurisDetails(juris);

        let dialogRef = this.dialog.open(AlertComponent, {
            disableClose: true,
            panelClass: 'alert-modal',
            data: { message: this.pageContentService.getTxtJurisName('Home_AgencyConfirmContent', this.storageService.getLang(), juris.JurisName), showCancelBtn: true }
        });

        dialogRef.afterClosed().subscribe(cmd => {
            if (cmd) {
                if (cmd == 'Ok') {
                    this.isLoading = true;
                    this.showLoading = false;
                    window.localStorage.setItem('SelectedAgencyInfo', JSON.stringify(juris));
                } else {
                    this.showLoading = false;
                    this.dialog.closeAll();
                }
            }
            window.location.reload();
        });

    }
    cmdRedirectPermitWindow(screenName: string) {
        this.cmdMenu.emit(false);
        this.pageContentService.pageContentYN = true;
        let screen = screenName.split(' ').join('_');
        let strPage = 'citpermit/permit/' + screen;
        if (this.currentPage == ("/" + strPage)) {
            this.pageContentService.pageContentYN = false;
        }

        let link = [strPage];
        console.log(link);
        this.router.navigate(link)
            .then(success => {
                if (success) {
                    this.pageContentService.pageContentYN = false;
                }
                else {
                    this.pageContentService.pageContentYN = false;

                    if (this.currentPage != ("/" + strPage)) {
                        this.dialog.closeAll();

                        this.dialog.open(AuthenticationComponent, {
                            disableClose: true,
                            panelClass: "alert-modal",
                            data: {
                                message: strPage === 'services/location' ? 'House_Check' : 'The service is accessible to authenticated users only.',
                                RouterLink: strPage
                            }
                        });
                    }
                }
            })
            .catch(err => {
                this.pageContentService.pageContentYN = false;
            });
    }
    cmdRedirectJOB(strPage: string, filename: string, FormType: string, ScreenName: string) {

        var names = "services/pdfformsview";
        let CitizenUserID = this.storageService.getUserID();
        this.storageService.setPDFUrl(names + '/' + filename + '/' + FormType + '/' + ScreenName);
        this.storageService.SetRequestFormUrl('services/servicejobapp/' + filename + '/' + FormType + '/' + ScreenName);
        this.pageContentService.pageContentYN = true;

        if (this.currentPage == ("/" + strPage)) {
            this.pageContentService.pageContentYN = false;
        }

        let link = [strPage];
        let filename1 = [filename];
        this.router.navigate([link, filename])
        this.router.navigate(link)
            .then(success => {
                if (success) {
                    this.pageContentService.pageContentYN = false;
                }
                else {
                    this.pageContentService.pageContentYN = false;

                    if (this.currentPage != ("/" + strPage)) {
                        this.dialog.closeAll();
                        if (CitizenUserID == null || this.isAdminUser() || this.isSuperAdminUser()) {
                            this.dialog.open(AuthenticationComponent, {
                                disableClose: true,
                                panelClass: "alert-modal",
                                data: { message: strPage === 'Forms/PDFForm' ? 'PDFForm' : 'The service is accessible to authenticated users only.' }
                            });
                        }
                    }
                }
            })
            .catch(err => {
                this.pageContentService.pageContentYN = false;
            });
    }
    public isAdminUser(): boolean {
        if (this.storageService.getUserRole() == UserRole.Admin || this.storageService.getUserRole() == UserRole.SuperAdmin || this.storageService.getUserRole() === UserRole.Juris) {
            return true;
        }
        else {
            return false;
        }
    }

    public isSuperAdminUser(): boolean {
        if (this.storageService.getUserRole() == UserRole.SuperAdmin)
            return true;
        else
            return false;
    }

    public isCitizen(): boolean {
        if (this.storageService.getUserRole() == UserRole.Citizen) {
            return true;
        }
        else {
            return false;
        }
    }

    public getPawn(): boolean {
        if (this.storageService.getPawn() == true) {
            return true;
        }
        else {
            return false;
        }
    }
    GetCSPReportsList(JurisId: number) {
        this.cspreportService.GetCSPReportsList(JurisId).then(
            (response) => {
                this.cspreportList = response;
            },
            (err) => {
                console.log("On Load Error CSP Report: " + err);
            });
        console.log("JurisId: " + JurisId);
    }

    OpenReportsWindow(CSPReportID: string) {
        this.router.navigateByUrl('services/reportspdfview/' + CSPReportID);


    }

}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/layout/leftmenu.component.ts